import {
  LOYALTY_MODAL_AUTOSHOW_DATA,
  LOYALTY_MODAL_AUTOSHOW_DELAY,
} from '../constants/local-storage-constants';

export interface ILocalStorageAutoshowLoyaltyRegistrationModalData {
  expiry: number;
}

export const getLoyaltyAutoShowLoyaltyKey = (customerId: string) =>
  `${LOYALTY_MODAL_AUTOSHOW_DATA}_${customerId}`;

export const autoshowLoyaltyRegistrationModal = (customerId: string): { needShow: boolean } => {
  const storageKey = getLoyaltyAutoShowLoyaltyKey(customerId);

  const setStorageData = () => {
    localStorage.setItem(
      storageKey,
      JSON.stringify({
        expiry: new Date().getTime() + LOYALTY_MODAL_AUTOSHOW_DELAY,
      }),
    );
  };

  const data = localStorage.getItem(storageKey);

  if (data) {
    const parsedData: ILocalStorageAutoshowLoyaltyRegistrationModalData = JSON.parse(data);
    const needShow = new Date().getTime() > parsedData.expiry;

    if (needShow) {
      setStorageData();
    }

    return {
      needShow,
    };
  }

  setStorageData();

  return {
    needShow: true,
  };
};
